module.exports = __webpack_public_path__ + "static/media/zhaiquan.8ce8d17a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/zhaiquan.png
// module id = 2187
// module chunks = 0